import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function WhyItFailed() {
  const reasons = [{
    title: 'Googlear no funciona',
    desc: 'porque las fuentes se contradicen constantemente.'
  }, {
    title: 'Seguir consejos de influencers no es seguro',
    desc: 'porque ellos no conocen tu biología.'
  }, {
    title: 'Comprar lo más barato suele salir caro',
    desc: 'ya que estás consumiendo "rellenos" en lugar de nutrientes activos.'
  }];
  return <Section bg="white" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-194">
          Por qué lo que has intentado no ha funcionado
        </h2>

        <div className="space-y-6" data-id="element-195">
          {reasons.map((reason, idx) => <div key={idx} className="flex items-start gap-4 p-6 rounded-xl bg-cream border border-sage-100" data-id="element-196">
              <XCircle className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-197" />
              <div data-id="element-198">
                <h3 className="text-xl font-bold text-charcoal mb-1 line-through decoration-terracotta/50 decoration-2" data-id="element-199">
                  {reason.title}
                </h3>
                <p className="text-charcoal-light text-lg" data-id="element-200">{reason.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}